<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body text-center" *ngIf="!loadingPrice">
    <div class="form">
        <div class="body">
            <section class="container-custom flex">
                <article class="flex_content">
                    <h2>Increase Limit</h2>
                    <h4>{{ employeePrice | currency:'PHP':'symbol' }} / Employee (VAT Excluded)</h4>

                    <ul>
                        <li>Each additional employee incurs a cost.</li>
                        <li>The cost of adding an employee will be added to your monthly subscription.</li>
                    </ul>

                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Additional Employees</mat-label>
                        <input matInput type="number" [(ngModel)]="employeesToAdd" min="1" placeholder="Enter number of employees">
                    </mat-form-field>

                    <button class="btn btn-success" type="submit" *ngIf="!isLoading; else loadingTemplate"
                        (click)="addEmployee(employeePrice)">
                        Select
                    </button>

                    <ng-template #loadingTemplate>
                        <button class="btn btn-success" type="submit">
                            Select <span class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                        </button>
                    </ng-template>
                </article>
            </section>
        </div>
    </div>
</div>
<div class="modal-body text-center price-loading" *ngIf="loadingPrice">
    <mat-spinner></mat-spinner>
    <p>Loading please wait...</p>
</div>